import { render, staticRenderFns } from "./TherapistDashModalShowLocationInfo.vue?vue&type=template&id=8d3c8d7c&scoped=true"
import script from "./TherapistDashModalShowLocationInfo.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalShowLocationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3c8d7c",
  null
  
)

export default component.exports